import { Badge, Avatar } from '../../widgets';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { IReplyList } from '../../inter/detail';
import { ActionType } from '../../types';
import { TrashIcon, PencilAltIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
dayjs.extend(utc);
dayjs.extend(timezone);

const PopupItem = ({
  props,
  active,
  action,
}: {
  props: IReplyList;
  active: boolean;
  action(type: ActionType, item: { id: string }): void;
}): JSX.Element => {
  return (
    <div
      className={clsx(
        active ? 'bg-blue-50 border border-blue-500' : 'bg-gray-50',
        'p-4 flex flex-col rounded-md shadow-xs',
      )}
    >
      <div className="flex space-x-3 items-start">
        <div className="w-10 h-10">
          <Avatar
            title={props.customer.name}
            isModerator={props.customer.isModerator}
          />
        </div>
        <div className="flex flex-1 space-y-1 flex-col">
          <div className="space-x-2 flex justify-between items-center">
            <span className="font-medium text-gray-900 text-sm">
              {props.customer.name}
            </span>
            <span className="text-gray-500 text-xs">
              {dayjs.utc(props.createdAt).format('DD/MM/YYYY HH:mm')}
            </span>
          </div>
          <div className="flex w-full justify-between items-center">
            <div className="flex flex-1">
              <p
                className="text-gray-700 text-sm line-clamp-2"
                title={props.desc}
              >
                {props.desc}
              </p>
            </div>
            <div className="flex flex-1 justify-end">
              <Badge status={props.status} />
            </div>
          </div>
        </div>
      </div>
      <div className="whitespace-nowrap mt-2 flex-1 space-x-3 flex justify-end items-center">
        <button
          type="button"
          title="Chỉnh sửa trả lời"
          className="w-6 h-6 inline-flex justify-center items-center bg-blue-50 text-blue-600 hover:bg-blue-100 rounded-md"
          onClick={() => {
            action(ActionType.edit, { id: props.id });
          }}
        >
          <PencilAltIcon className="w-4 h-4" />
        </button>
        <button
          type="button"
          title="Xoá trả lời"
          className="w-6 h-6 inline-flex justify-center items-center bg-red-50 text-red-600 hover:bg-red-100 rounded-md"
          onClick={() => {
            action(ActionType.delete, { id: props.id });
          }}
        >
          <TrashIcon className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default PopupItem;
